import React, {Component} from 'react'
import {Control, Errors, actions} from 'react-redux-form'
import {FormGroup, Radio} from 'react-bootstrap'
import {validators} from "../../../../utils/validators"
import PropTypes from 'prop-types';

class RequiredRadioGroup extends Component {

  state = {};

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render(){
    const {model, radios, controlId, errorLabel, ...props} = this.props;

    return (
      <FormGroup controlId={controlId} validationState={this.state[errorLabel]}>
        {radios.map((radio, key) => (
            <div key={key}>
              <Control.radio
                model={model}
                validators={{required: validators.required(this.updateErrors, errorLabel)}}
                component={Radio}
                value={radio.value}
                {...props}
              >
                {radio.label}
              </Control.radio>
            </div>
          ))
        }

        <Errors
          show={{touched: true, focus: false}}
          className="errors"
          model={model}
          messages={{
            required: 'This field is required',
          }}/>
      </FormGroup>
    )
  }
}

RequiredRadioGroup.propTypes = {
  model: PropTypes.string.isRequired,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
  radios: PropTypes.array,
};

RequiredRadioGroup.defaultProps = {
  controlId: Math.random().toString(16).substring(2),
  errorLabel: 'error',
};

export default RequiredRadioGroup;


// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-radio-group.jsx